export default __webpack_public_path__ + "static/media/bag.07c21b16.svg";